import hasWhitespacesOnly from './common/hasWhitespacesOnly';
import incorrectDataType from './common/incorrectDataType';
import isEmpty from './common/isEmpty';
import isNull from './common/isNull';
import isUndefined from './common/isUndefined';

export const isValidBankAccountNumber = (account_number) => {
  if (
    isNull(account_number) ||
    isUndefined(account_number) ||
    incorrectDataType(account_number, 'string') ||
    hasWhitespacesOnly(account_number) ||
    isEmpty(account_number)
  ) {
    return false;
  } else {
    const regex_account_number = new RegExp(/^[0-9]+$/);
    return (
      account_number.length >= 9 &&
      account_number.length <= 18 &&
      regex_account_number.test(account_number)
    );
  }
};

export const filterBankAccountNumber = (account_number) => {
  const account_number_filtered = account_number.replace(/\D+/g, '');
  return account_number_filtered;
};
